<template>
	<section class="hotel-facilities-grid">
		<div class="hotel-facilities-grid__left">
			<HotelFacility
				v-for="attribute in chunks.at(0)"
				:key="attribute.Name"
				:attribute="attribute"
			/>
		</div>
		<div class="hotel-facilities-grid__right">
			<HotelFacility
				v-for="attribute in chunks.at(1)"
				:key="attribute.Name"
				:attribute="attribute"
			/>
		</div>
		<HotelInfoDisclaimer class="hotel-facilities-grid__legal" />
	</section>
</template>
<script lang="ts" setup>
import { computed } from 'vue';
import HotelInfoDisclaimer from '@lmt-rpb/Atoms/HotelInfoDisclaimer/HotelInfoDisclaimer.vue';
import type { Attribute } from '@/interfaces/offer-list-types/offer-list-typo-hotel-data';
import HotelFacility from './HotelFacility.vue';
import { chunkArray } from '@/js/utils/arrayUtils';

interface Props {
	attributes: Attribute[];
}
const props = withDefaults(defineProps<Props>(), {
	attributes: () => [],
});

const chunks = computed(() => chunkArray(props.attributes, 2));

</script>

<style lang="scss" scoped>
.hotel-facilities-grid {
	display: grid;
	grid-template-columns: 1fr;
	gap: 2.4rem;

	&__left,
	&__right {
		display: flex;
		flex-direction: column;
		align-items: flex-start;
		gap: 2.4rem;
	}

	@media screen and (min-width: $breakpoint-small) {
		grid-template-columns: repeat(2, 1fr);

		&__legal {
			grid-column: 1 / -1;
		}
	}

	@media screen and (min-width: $breakpoint-large) {
		grid-template-columns: repeat(3, 1fr);

		&__legal {
			grid-column: unset;
		}
	}
}
</style>
